import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
//import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip'
import CheckIcon from '@material-ui/icons/Check'
import AccessTimeIcon from '@material-ui/icons/AccessTime'

import SubmitDialog from './SubmitDialog'

import t from '../utils/lang'

const styles = theme => ({
  rfpSelect: {
    minWidth: 200,
    marginLeft: 32,
    '@media screen and (max-width: 768px)': {
      display: 'none'
    }
  }
});

class Header extends Component {
  state = {
    lang: 'en',
    openSubmitDialog: false
  }

  handleSubmitDialogOpen = (event) => {
    this.setState({ openSubmitDialog: true });
  }

  handleSubmitDialogClose = () => {
    this.setState({ openSubmitDialog: false });
  }

  handleChangeRFP = e => {
    const { otherRFPs } = this.props;
    const clickedRFP = otherRFPs.find(el => Number(el.id) === Number(e.target.value))
    window.location = clickedRFP.link;
  }

  componentDidUpdate(prevProps) {
    const { lang } = this.props

    if (lang !== prevProps.lang) {
      this.setState({ lang })
    }
  }

  render() {
    const { lang, openSubmitDialog } = this.state
    const { classes, id, statusId, daysLeft, timeLeft, dueDateFormatted, propertyName, otherRFPs, isFlex } = this.props

    return (
      <div className='app-header'>
        <AppBar position="fixed" color="default">
          <Toolbar className='app-toolbar' style={{ minHeight: 64 }}>
            <div className='logo-container'>
              <img src='/static/images/jll_logo_black.svg' alt='JLL logo' />
              {otherRFPs && otherRFPs.length > 1 && propertyName && <FormControl className={classes.rfpSelect}>
                <Select
                  value={0}
                  onChange={this.handleChangeRFP}
                >
                  <MenuItem value={0} selected>
                    {propertyName}
                  </MenuItem>
                  {otherRFPs.map(({ id, name }) => 
                    <MenuItem value={id}>{name}</MenuItem>
                  )}
                </Select>
              </FormControl>}
            </div>

            <div className="toolbar-right-panel">
              {statusId === 3 && (
                <div className='rfp-submitted'>
                  <CheckIcon style={{ fontSize: 20, verticalAlign: 'middle' }} /> {t[lang].proposalSubmitted}
                </div>)}

              {statusId !== 3 && (
                <Fragment>
                  {!isFlex && <div className='due-date'>
                    <Tooltip title={dueDateFormatted ? dueDateFormatted : ''}>
                      <div><AccessTimeIcon style={{ fontSize: 20, verticalAlign: 'middle' }} /> {timeLeft}</div>
                    </Tooltip>
                  </div>}
                  <div className='submit-rfp'>
                    <Tooltip title={t[lang].submitProposalTitle}>
                      <div>
                        <Button variant="contained" color='secondary' disabled={daysLeft < 0} onClick={event => this.handleSubmitDialogOpen(event)}>
                          {t[lang].submitProposal}
                        </Button>
                      </div>
                    </Tooltip>
                  </div>
                </Fragment>)}
              </div>
          </Toolbar>
        </AppBar>
        <SubmitDialog lang={lang} open={openSubmitDialog} handleClose={this.handleSubmitDialogClose} />
      </div>
    )
  }
}

function mapStateToProps({ rfpData, otherRFPs }) {
  const { id, statusId, daysLeft, timeLeft, dueDateFormatted, propertyName, lang, isFlex } = rfpData

  return {
    id,
    statusId,
    daysLeft,
    timeLeft,
    dueDateFormatted,
    propertyName,
    otherRFPs: otherRFPs ? Object.values(otherRFPs) : [],
    lang,
    isFlex
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Header))


// WEBPACK FOOTER //
// ./src/components/Header.js